import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  InputAdornment,
} from "@mui/material";
import { Person, Email, LocationOn, Phone } from "@mui/icons-material";

interface EditVehicleDialogProps {
  open: boolean;
  onClose: () => void;
  vehicle: {
    id: number;
    name: string;
    address: string;
    password: string;
    email: string;
    phone_number: string;
  } | null;
  onVehicleUpdated: () => void;
}

const EditVehicleDialog: React.FC<EditVehicleDialogProps> = ({
  open,
  onClose,
  vehicle,
  onVehicleUpdated,
}) => {
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [phone_number, setPhoneNumber] = useState("");

  useEffect(() => {
    if (vehicle) {
      setName(vehicle.name);
      setAddress(vehicle.address);
      setEmail(vehicle.email);
      setPhoneNumber(vehicle.phone_number);
    }
  }, [vehicle]);

  const handleSubmit = () => {
    if (!vehicle) return;
  
    
    const updatedUser = {
      name,
      address,
      email,
      phone_number,
     
      
    };
  
    const token: string | null = localStorage.getItem("token");
    if (!token) return;
  
    fetch(`${process.env.REACT_APP_API_BASE_URL}/vehicle/${vehicle.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": token,
      },
      body: JSON.stringify(updatedUser),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message) {
          console.error("Error updating Vehicle:", data.message);
        } else {
          onVehicleUpdated();
          onClose();
        }
      })
      .catch((error) => console.error("Error updating vehicle:", error));
  };
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: "#121212",
          border: "2px solid green",
          borderRadius: "12px",
          padding: "16px",
          width: "400px",
        },
      }}
    >
      <DialogTitle sx={{ color: "green", textAlign: "center" }}>
        Edit User
      </DialogTitle>
      <DialogContent>
        {/* Name */}
        <TextField
          margin="dense"
          label="Name"
          type="text"
          fullWidth
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Person sx={{ color: "white" }} />
              </InputAdornment>
            ),
          }}
          sx={{
            input: { color: "white" },
            label: { color: "white" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "white" },
              "&:hover fieldset": { borderColor: "limegreen" },
              "&.Mui-focused fieldset": { borderColor: "limegreen" },
            },
          }}
        />

        {/* Email */}
        <TextField
          margin="dense"
          label="Email"
          type="email"
          fullWidth
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Email sx={{ color: "white" }} />
              </InputAdornment>
            ),
          }}
          sx={{
            input: { color: "white" },
            label: { color: "white" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "white" },
              "&:hover fieldset": { borderColor: "limegreen" },
              "&.Mui-focused fieldset": { borderColor: "limegreen" },
            },
          }}
        />

        {/* Address */}
        <TextField
          margin="dense"
          label="Address"
          type="text"
          fullWidth
          variant="outlined"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <LocationOn sx={{ color: "white" }} />
              </InputAdornment>
            ),
          }}
          sx={{
            input: { color: "white" },
            label: { color: "white" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "white" },
              "&:hover fieldset": { borderColor: "limegreen" },
              "&.Mui-focused fieldset": { borderColor: "limegreen" },
            },
          }}
        />

        {/* Phone Number */}
        <TextField
          margin="dense"
          label="Phone Number"
          type="tel"
          fullWidth
          variant="outlined"
          value={phone_number}
          onChange={(e) => setPhoneNumber(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Phone sx={{ color: "white" }} />
              </InputAdornment>
            ),
          }}
          sx={{
            input: { color: "white" },
            label: { color: "white" },
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "white" },
              "&:hover fieldset": { borderColor: "limegreen" },
              "&.Mui-focused fieldset": { borderColor: "limegreen" },
            },
          }}
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button
          onClick={onClose}
          sx={{ color: "white", border: "1px solid green" }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          sx={{ backgroundColor: "green", color: "black" }}
        >
          Update User
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditVehicleDialog;
